import React, { useState } from 'react';
import './customDatePicker.scss';
import { useTranslation } from 'react-i18next';


interface Props {
  value: string;
  onChange: (val: string) => void;
  label?: string;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const months = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

const CustomDatePicker: React.FC<Props> = ({
  value,
  onChange,
  label,
  isOpen,
  onOpen,
  onClose,
}) => {
  const today = new Date();
  const [month, setMonth] = useState(today.getMonth());
  const [year, setYear] = useState(today.getFullYear());
    const { t } = useTranslation();
  

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDay = (new Date(year, month, 1).getDay() + 6) % 7;

  const selectDate = (day: number) => {
    const mm = String(month + 1).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    onChange(`${year}-${mm}-${dd}`);
    onClose(); // 👈 CLOSE after select
  };

  return (
    <div className="cdp-wrapper">
      {label && <label>{label}</label>}

      <div className="cdp-input-wrapper" onClick={onOpen}>
  <input
    type="text"
    className="filter-input"
    placeholder="YYYY-MM-DD"
    value={value}
    readOnly
  />

  <span className="cdp-icon">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M8 2V5" stroke="#68727d" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M16 2V5" stroke="#68727d" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="3" y="4" width="18" height="15" rx="2" stroke="#68727d" strokeWidth="1.5" />
      <path d="M3 10H21" stroke="#68727d" strokeWidth="1.5" />
      <path d="M8 14H8.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 14H12.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
      <path d="M16 14H16.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
      <path d="M8 17H8.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
      <path d="M12 17H12.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
      <path d="M16 17H16.01" stroke="#68727d" strokeWidth="2" strokeLinecap="round" />
    </svg>
  </span>
</div>

      {isOpen && (
        <div className="cdp-modal">
          <div className="cdp-header">
            <span>{t('Choose from date')}</span>
            <button onClick={onClose}>×</button>
          </div>

          <div className="cdp-controls">
            <span>{months[month]}</span>

            <select value={year} onChange={(e) => setYear(+e.target.value)}>
              {Array.from({ length: 15 }, (_, i) => today.getFullYear() - 5 + i)
                .map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
            </select>

            <div className="arrows">
              <button onClick={() => setMonth(m => (m === 0 ? 11 : m - 1))}>‹</button>
              <button onClick={() => setMonth(m => (m === 11 ? 0 : m + 1))}>›</button>
            </div>
          </div>

          <div className="cdp-week">
            {['Mo','Tu','We','Th','Fr','Sa','Su'].map(d => (
              <span key={d}>{d}</span>
            ))}
          </div>

          <div className="cdp-grid">
            {Array(firstDay).fill(null).map((_, i) => (
              <span key={i} />
            ))}

            {Array.from({ length: daysInMonth }, (_, i) => (
              <button key={i} onClick={() => selectDate(i + 1)}>
                {i + 1}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDatePicker;